/**
 *
 * Asynchronously loads the component for UsernameSuccessPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UsernameSuccessPage = lazyLoad(
  () => import('./index'),
  module => module.UsernameSuccessPage,
);
